export default {
  title: 'AI Plan Creator',
  greeting: 'Hi! I\'m here to help you create a Plan Optimization. What do you need?',
  describeRequirements: 'Describe your requirements',
  enterRequirements: 'Enter your requirements here...',
  next: 'Next'
}
